export default __webpack_public_path__ + "static/media/Add-Address.3d83f000.jpg";